import React from 'react';
import { Paper, Box, Typography, Chip, Card, CardContent } from '@mui/material';
import { Warning } from '@mui/icons-material';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import UserDetailsPayments from './UserDetailsPayments';

dayjs.locale('it');

const UserDetailsCourses = ({ enrollments, userId }) => {
  const getPaymentMethodLabel = (method) => {
    const labels = {
      monthly: 'Mensile',
      annual3: 'Annuale 3 rate',
      annual1: 'Annuale 1 rata',
    };
    return labels[method] || method;
  };

  // const getPaymentStatusColor = (status) => {
  //   switch (status) {
  //     case 'completed':
  //       return 'success';
  //     case 'pending':
  //       return 'warning';
  //     case 'failed':
  //       return 'error';
  //     default:
  //       return 'default';
  //   }
  // };

  const getPaymentStatusLabel = (enrollment) => {
    if (enrollment.paymentStatusInfo?.isEnrollmentPaid) {
      return 'Pagato';
    }
    if (enrollment.paymentStatusInfo?.isUpkeepPaid) {
      return 'Rata pagata';
    }
    return 'Non pagato';
  };

  const isCourseExpired = (endDate) => {
    return endDate && dayjs(endDate).isBefore(dayjs(), 'day');
  };

  if (!enrollments || enrollments.length === 0) {
    return (
      <Paper sx={{ p: 3 }}>
        <Typography variant='h6' sx={{ mb: 2 }}>
          Corsi Iscritti
        </Typography>
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant='body2' color='text.secondary'>
            Nessun corso associato
          </Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant='h6' sx={{ mb: 2 }}>
        Iscrizione Corsi e Pagamenti
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {enrollments.map((enrollment) => {
          const course = enrollment.course;
          const expired = isCourseExpired(course?.endDate);
          const isSuspended = enrollment.status === 'suspended';
          const paymentStatusInfo = enrollment.paymentStatusInfo;

          return (
            <Card key={enrollment._id} variant='outlined'>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                  <Box>
                    <Typography variant='h6' gutterBottom>
                      {course?.name || 'Corso senza nome'}
                    </Typography>
                    <Typography variant='body2' color='text.secondary'>
                      Docente: {course?.teacher?.name || 'N/A'} {course?.teacher?.surname || ''}
                    </Typography>
                    <Typography variant='body2' color='text.secondary'>
                      Sede: {course?.venue}
                    </Typography>
                    {course?.startDate && (
                      <Typography variant='body2' color='text.secondary'>
                        Periodo: {dayjs(course.startDate).format('DD MMM YYYY')} - {course.endDate ? dayjs(course.endDate).format('DD MMM YYYY') : 'Indefinito'}
                      </Typography>
                    )}
                    <Typography variant='body2' color='text.secondary'>
                      Iscritto da: {dayjs(enrollment.startDate).format('MMMM YYYY')}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    {isSuspended && <Chip label='Sospeso' color='error' size='small' />}
                    {expired && <Chip icon={<Warning />} label='Scaduto' color='warning' size='small' />}
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 2 }}>
                  <Chip label={`Metodo: ${getPaymentMethodLabel(enrollment.paymentMethod)}`} size='small' variant='outlined' />
                  <Chip
                    label={`Stato: ${getPaymentStatusLabel(enrollment)}`}
                    size='small'
                    color={paymentStatusInfo?.isEnrollmentPaid ? 'success' : 'warning'}
                  />
                </Box>
                {paymentStatusInfo && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0, mt: 2 }}>
                    <Typography variant='body2' color='text.secondary'>
                      Pagamenti dovuti: {paymentStatusInfo._paymentsDue}
                    </Typography>
                    <Typography variant='body2' color='text.secondary'>
                      Pagamenti fatti: {paymentStatusInfo.paymentsMade}
                    </Typography>
                    <Typography variant='body2' color='text.secondary'>
                      Pagamenti in ritardo: {paymentStatusInfo.paymentsLate}
                    </Typography>
                    <Typography variant='body2' color='text.secondary'>
                      Prossima scadenza: {paymentStatusInfo.nextPaymentDate ? dayjs(paymentStatusInfo.nextPaymentDate).format('DD MMM YYYY') : 'N/A'}
                    </Typography>
                  </Box>
                )}
                <UserDetailsPayments userId={userId} enrollmentId={enrollment._id} />
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Paper>
  );
};

export default UserDetailsCourses;
